import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { KioskSyncModel } from 'app/models/kiosk-sync-model';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';

@Component({
  selector: 'app-admin-kiosk-sync-page',
  templateUrl: './admin-kiosk-sync.page.html',
  styleUrls: ['./admin-kiosk-sync.page.scss']
})
export class KioskSyncPage implements OnInit {
  kioskSyncs: KioskSyncModel[] = [];
  displayedColumns: string[] = ['status', 'aggregate', 'versions', 'pendingChanges', 'lastAckAt', 'lastIssueAt', 'updatedAt'];
  loading = false;

  constructor(
    private restService: RestService,
    public appService: AppService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.loadKioskSyncs();
  }

  loadKioskSyncs(): void {
    this.loading = true;
    this.restService.getKioskSyncs().subscribe({
      next: (result) => {
        this.kioskSyncs = this.extractContent(result);
        this.loading = false;
      },
      error: () => {
        this.kioskSyncs = [];
        this.loading = false;
      }
    });
  }

  openDetails(row: KioskSyncModel): void {
    this.restService.getKioskSync(row.id).subscribe((kioskSync: KioskSyncModel) => {
      this.dialog.open(AdminKioskSyncDetails, {
        panelClass: 'responsive-dialog',
        maxWidth: '95vw',
        data: { kioskSync }
      });
    });
  }

  totalItems(): number {
    return this.kioskSyncs.length;
  }

  statusClass(status?: string): string {
    const value = (status || '').toUpperCase();

    if (value.includes('OK') || value.includes('SYNCED') || value.includes('ACK')) {
      return 'ks-chip ks-chip--success';
    }

    if (value.includes('ERROR') || value.includes('FAILED') || value.includes('ISSUE')) {
      return 'ks-chip ks-chip--danger';
    }

    if (value.includes('PENDING') || value.includes('SYNC')) {
      return 'ks-chip ks-chip--warning';
    }

    return 'ks-chip ks-chip--neutral';
  }

  formatEnumLabel(value?: string): string {
    if (!value) {
      return '-';
    }

    return value
      .split('_')
      .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
      .join(' ');
  }

  formatDateTime(value?: string | number): string {
    if (!value) {
      return '-';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return String(value);
    }

    return date.toLocaleString('es-ES');
  }

  valueOrDash(value: unknown): string {
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    return String(value);
  }

  pendingChangesLabel(value?: boolean): string {
    return value ? 'Sí' : 'No';
  }

  versionsLabel(row: KioskSyncModel): string {
    return `${this.valueOrDash(row.lastAckVersion)} / ${this.valueOrDash(row.expectedVersion)}`;
  }

  private extractContent(result: any): KioskSyncModel[] {
    if (Array.isArray(result)) {
      return result;
    }

    if (Array.isArray(result?.content)) {
      return result.content;
    }

    return [];
  }
}

@Component({
  selector: 'app-admin-kiosk-sync-details',
  templateUrl: './admin-kiosk-sync-details.component.html',
  styleUrls: ['./admin-kiosk-sync.page.scss']
})
export class AdminKioskSyncDetails {
  kioskSync: KioskSyncModel;

  constructor(
    public dialogRef: MatDialogRef<AdminKioskSyncDetails>,
    @Inject(MAT_DIALOG_DATA) public data: { kioskSync: KioskSyncModel },
    public appService: AppService
  ) {
    this.kioskSync = data?.kioskSync;
  }

  close(): void {
    this.dialogRef.close();
  }

  statusClass(status?: string): string {
    const value = (status || '').toUpperCase();

    if (value.includes('OK') || value.includes('SYNCED') || value.includes('ACK')) {
      return 'ks-chip ks-chip--success';
    }

    if (value.includes('ERROR') || value.includes('FAILED') || value.includes('ISSUE')) {
      return 'ks-chip ks-chip--danger';
    }

    if (value.includes('PENDING') || value.includes('SYNC')) {
      return 'ks-chip ks-chip--warning';
    }

    return 'ks-chip ks-chip--neutral';
  }

  formatEnumLabel(value?: string): string {
    if (!value) {
      return '-';
    }

    return value
      .split('_')
      .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
      .join(' ');
  }

  formatDateTime(value?: string | number): string {
    if (!value) {
      return '-';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return String(value);
    }

    return date.toLocaleString('es-ES');
  }

  valueOrDash(value: unknown): string {
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    return String(value);
  }

  pendingChangesLabel(value?: boolean): string {
    return value ? 'Sí' : 'No';
  }

  formatJson(value: unknown): string {
    if (value === null || value === undefined || value === '') {
      return 'Sin contenido';
    }

    if (typeof value === 'string') {
      try {
        return JSON.stringify(JSON.parse(value), null, 2);
      } catch {
        return value;
      }
    }

    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return String(value);
    }
  }
}
